import React, { useState } from 'react';

// Import demo components here as you create them
import MedDRADemo from './MedDRADemo';
// import AnotherDemo from './AnotherDemo';

// Map case study IDs to their demo components
const demoRegistry = {
  'meddra-autocoder': MedDRADemo,
  // 'another-case-study': AnotherDemo,
};

export default function CaseStudyModal({ caseStudy, onClose }) {
  const [showDemo, setShowDemo] = useState(false);
  
  if (!caseStudy) return null;

  // Get demo component if one exists for this case study
  const DemoComponent = caseStudy.hasInteractiveDemo ? demoRegistry[caseStudy.id] : null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white border-2 border-black rounded-lg max-w-4xl max-h-[90vh] overflow-y-auto shadow-[12px_12px_0px_0px_rgba(0,0,0,1)]" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b-2 border-black p-6 flex justify-between items-start z-10">
          <div>
            <h2 className="text-3xl font-black mb-2">{caseStudy.title}</h2>
            <p className="text-sm text-neutral-600">{caseStudy.role} | {caseStudy.timeline}</p>
          </div>
          <button 
            onClick={onClose}
            className="text-2xl font-bold hover:bg-neutral-100 w-10 h-10 flex items-center justify-center rounded border-2 border-black"
          >
            ×
          </button>
        </div>

        <div className="p-6 space-y-8">
          <div>
            <p className="text-base leading-relaxed mb-4">{caseStudy.summary}</p>
            <p className="text-sm leading-relaxed text-neutral-700">
              <strong>The Problem:</strong> {caseStudy.problem}
            </p>
          </div>

          {/* Interactive Demo - only renders if DemoComponent exists */}
          {DemoComponent && (
            <div>
              <h3 className="text-xl font-black mb-3 pb-2 border-b-2 border-black inline-block">Interactive Prototype</h3>
              <p className="text-sm text-neutral-600 mb-4">
                Functional prototype demonstrating the core workflow.
              </p>
              
              {!showDemo ? (
                <button
                  onClick={() => setShowDemo(true)}
                  className="px-6 py-3 bg-emerald-500 text-white font-bold border-2 border-black hover:bg-emerald-600 transition-colors rounded-md shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[-2px] hover:translate-y-[-2px]"
                >
                  Launch Demo →
                </button>
              ) : (
                <div className="space-y-3">
                  {/* Fixed height container for demo - prevents layout shift */}
                  <div className="w-full" style={{ minHeight: '600px' }}>
                    <DemoComponent />
                  </div>
                  <button
                    onClick={() => setShowDemo(false)}
                    className="text-sm text-neutral-500 hover:text-neutral-700 underline"
                  >
                    Hide demo
                  </button>
                </div>
              )}
            </div>
          )}

          <div>
            <h3 className="text-xl font-black mb-3 pb-2 border-b-2 border-black inline-block">The Challenge</h3>
            <div className="whitespace-pre-line text-sm leading-relaxed">
              {caseStudy.fullContent.challenge}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-black mb-3 pb-2 border-b-2 border-black inline-block">Research & Discovery</h3>
            <div className="whitespace-pre-line text-sm leading-relaxed">
              {caseStudy.fullContent.research}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-black mb-3 pb-2 border-b-2 border-black inline-block">Solution</h3>
            <div className="whitespace-pre-line text-sm leading-relaxed">
              {caseStudy.fullContent.solution}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-black mb-3 pb-2 border-b-2 border-black inline-block">Results & Impact</h3>
            <div className="whitespace-pre-line text-sm leading-relaxed mb-4">
              {caseStudy.fullContent.results}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-black mb-3 pb-2 border-b-2 border-black inline-block">Key Learnings</h3>
            <div className="whitespace-pre-line text-sm leading-relaxed">
              {caseStudy.fullContent.learnings}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-black mb-3">Skills Demonstrated</h3>
            <div className="flex flex-wrap gap-2">
              {caseStudy.skills.map((skill, i) => (
                <span key={i} className="px-3 py-1 bg-neutral-100 border border-black text-xs font-medium rounded">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="sticky bottom-0 bg-white border-t-2 border-black p-6">
          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-black text-white font-bold border-2 border-black hover:bg-neutral-800 transition-colors rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}